module.exports = __webpack_public_path__ + "static/media/app_bg.983e668a.jpg";